(() => {
  const addButtons = qsa('.js-recipe-products__add-button');
  const headerCart = qs('#js-header-cart-count');
  const miniCart = qs('.js-mini-cart');

  addButtons && addButtons.forEach(addButton => {
    addButton.addEventListener('click', async (e) => {
      e.preventDefault();
      const parent = getClosest('.recipe-products__item', e.currentTarget);
      let variant_id = qs('input[name="id"]', parent).value;

      const wishlist = qs('.js-product-card-wishlist', parent);
      const wishlistActive = 'product-card__wishlist--active';
      wishlist && wishlist.addEventListener('click', (e) => {
        e.preventDefault();
        const el = e.currentTarget;
        if (el.classList.contains(wishlistActive)) {
          el.classList.remove(wishlistActive);
        } else {
          el.classList.add(wishlistActive);
        }
      });

      const data = {
        id: variant_id,
        quantity: 1,
      };

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            if(headerCart) {
              const currentCount = headerCart.innerText;
              headerCart.innerText = Number(currentCount) + 1;
            }

            miniCart && miniCart.classList.add('mini-cart--active');
            scrollLock();
            refreshMiniCart();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    });
  });


  function refreshMiniCart() {
    const miniCart = qs('.js-mini-cart');
    if(miniCart) {
      fetch(window.Shopify.routes.root + '?sections=mini-cart')
        .then((res) => res.json())
        .then((res) => {
          let template = document.createElement('div');
          template.innerHTML = res['mini-cart'];
          let oldContainer = qs('.js-mini-cart__container', miniCart);
          let newContainer = qs('.js-mini-cart__container', template);
  
          oldContainer.innerHTML = newContainer.innerHTML;
        });
    }
  }

})();